// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__Pog6E"};